<template>
  <div class="row">
    <div class="col-md-2 offset-md-10">
      <router-link :to="{ name: 'Create Reward'}" style="float:right">
        <p-button type="primary" round>
          Add New Reward Program
        </p-button>
      </router-link>
    </div>
    <div class="col-md-12">
      <div class="card">
        <div class="card-header"></div>
        <div class="card-body">
          <div class="col-sm-12">
            <el-table class="table-striped"
                      :data="queriedData"
                      empty-text="You have not created any reward system."
                      stripe
                      border
                      style="width: 100%">
              <el-table-column v-for="column in tableColumns"
                              :key="column.label"
                              :min-width="column.minWidth"
                              :prop="column.prop"
                              :label="column.label">
              </el-table-column>
              <el-table-column
                class-name="td-actions"
                >
                <template slot-scope="props">
                  <router-link :to="{ name: 'Update Budget', params: { id: props.row.id }}">
                    <p-button type="primary" round>Suspend</p-button>
                  </router-link>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="col-sm-6 pagination-info">
            <p class="category">Showing {{from + 1}} to {{to}} of {{total}} entries</p>
          </div>
          <div class="col-sm-6">
            <p-pagination class="pull-right"
                          v-model="pagination.currentPage"
                          :per-page="pagination.perPage"
                          :total="pagination.total">
            </p-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { Card } from 'src/components/UIComponents'
  import ChartCard from 'src/components/UIComponents/Cards/ChartCard'
  import BarChart from 'src/components/UIComponents/Charts/HorizontalBarChart'
 

  import Vue from 'vue'
  import {Table, TableColumn, Select, Option} from 'element-ui'
  import PPagination from 'src/components/UIComponents/Pagination.vue'
  
  Vue.use(Table)
  Vue.use(TableColumn)
  Vue.use(Select)
  Vue.use(Option)

  export default {
    components: {
      Card,
      PPagination
    },
    computed: {
      pagedData () {
        return this.tableData.slice(this.from, this.to)
      },
      /***
       * Searches through table data and returns a paginated array.
       * Note that this should not be used for table with a lot of data as it might be slow!
       * Do the search and the pagination on the server and display the data retrieved from server instead.
       * @returns {computed.pagedData}
       */
      queriedData () {
        if (!this.searchQuery) {
          this.pagination.total = this.tableData.length
          return this.pagedData
        }
        let result = this.tableData
          .filter((row) => {
            let isIncluded = false
            for (let key of this.propsToSearch) {
              let rowValue = row[key].toString()
              if (rowValue.includes && rowValue.includes(this.searchQuery)) {
                isIncluded = true
              }
            }
            return isIncluded
          })
        this.pagination.total = result.length
        return result.slice(this.from, this.to)
      },
      to () {
        let highBound = this.from + this.pagination.perPage
        if (this.total < highBound) {
          highBound = this.total
        }
        return highBound
      },
      from () {
        return this.pagination.perPage * (this.pagination.currentPage - 1)
      },
      total () {
        this.pagination.total = this.tableData.length
        return this.tableData.length
      }
    },
    data() {
      return {
        loaded: false,

        model: {
          labels: []
        },
        
        pagination: {
          perPage: 10,
          currentPage: 1,
          perPageOptions: [10, 25, 50],
          total: 0
        },
        searchQuery: '',
        propsToSearch: ['businessName'],
        tableColumns: [
          {
            prop: 'businessName',
            label: 'Name of Business',
            minWidth: 300
          },
          {
            prop: 'generalPoint',
            label: 'Base Reward',
            minWidth: 100
          },
          {
            prop: 'updatedAt',
            label: 'Updated',
            minWidth: 100
          },
        ],
        tableData: []
      }
    },
    methods: {

      getMerchantRewards () {
        this.$http.get('/extension/rewards/merchants')
        .then(response => {

          
        })
        .catch(error => {
          
        })
      }
    },

    async mounted () {
      this.getBudget()
    }
  }
</script>
<style lang="scss">
  .el-table .td-actions{
    button.btn {
      margin-right: 5px;
    }
  }
</style>
